const getters = {
  getOrders: (state) => {
    return _.orderBy(state.orders, ['sequence'], 'asc');
  },
  getOrdersFromCargo: (state) => (id) => {
    return _.orderBy(_.filter(_.toArray(state.orders), (order) => {
      if(order !== undefined && order.cargoId)
        return order.cargoId.toString() === id;
    }), ['sequence'], 'asc');

  },
  getOrderIdsFromCargo: (state) => (id) => {
    let orders = _.orderBy(_.filter(state.orders, (order) => {
      return order.cargoId === id;
    }), ['sequence'], 'asc');

    return _.map(orders, (ord) => {
      return ord.id;
    });
  },
  getOrderFromProduct: (state) => (id) => {
    // add a return from order ID of that given product
  },
  // getAvailableSenders:(state,getters)=>{
  //  return _.sortBy(_.uniq(Object.keys(getters.getGroupedBySender)))
  // },
  // getGroupedBySender:(state)=>{
  //   let incomingOrders =  _.filter(state.orders,(order)=>{
  //     return order.cargoType == 'incoming'
  //   })
  //  let grouped =  _.groupBy(incomingOrders, (order)=>{
  //     return order.sender.name
  //   });
  //
  //  return grouped ? grouped : []
  // },
  getOrder: (state) => (id) => {
    return state.orders[id] ? state.orders[id] : false;
  },
  getCurrentOrderPicking: (state) => {
    return state.currentOrderPicking;
  },
  getCurrentProductPicking: (state) => {
    return state.currentProductPicking;
  },
  getReadyOrdersAndTotalFromCargo: (state, getters, rootState, rootGetters) => (cargoId) => {
    let orderProducts = rootGetters['orderProducts/getProductsFromCargo'](cargoId);
    return orderProducts;
  },

};

export default getters;